export default function (encodedId, user) {
    // create a download anchor tag
    var downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    downloadLink.download = `${user.firstName} ${user.surname} myKanisa_ID.pdf`;

    const downloadUrl = URL.createObjectURL(encodedId);

    // set object URL as the anchor's href
    downloadLink.href = downloadUrl;

    // append the anchor to document body
    document.body.appendChild(downloadLink);

    // fire a click event on the anchor
    downloadLink.click();

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        // cleanup: remove element and revoke object URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(downloadUrl);
        //
    }, 50);
}
